import { GLOBAL_STORE_NAME } from '@/constants/constants';
import { Inspection } from '@/types/inspection-types';
import {
  IInspectionConfiguration,
  IInspectionConfigurationFormData,
  QualityStandard
} from '@/types/types';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { clearClientStores } from '@/stores/clearClientStores';

/*
isScanning
state to determine which "Mechanic" module to render, e.g Robot, Flex, LinearUnit etc.
*/

const baseUrl = process.env.NEXT_PUBLIC_MARK_2_API;
const acqUrl = process.env.NEXT_PUBLIC_ACQUISITION;

interface GlobalState {
  //   inspection: Partial<Inspection>;
  selectedInspectionConfiguration: string; //id of inspection configuration as value
  inspectionConfigurations: any[];

  quality_standards: QualityStandard[];
  isStoreHydrated: boolean;
  currentSystem: any; //contains laser type, measurement_field, controller_type, etc..
}
type Actions = {
  //   updateInspection: (formData: Partial<Inspection>) => void;
  fetchSystemData: () => Promise<void>;
  updateSelectedInspectionConfiguration: (
    inspectionConfiguration: string
  ) => void;
  fetchInspectionConfiguration: () => Promise<void>;
  fetchQualityStandard: () => Promise<void>;
  // getCurrentInspection: () => Promise<void>;
  setIsStoreHydrated: (isHydrated: boolean) => void;
  resetStore: () => void;
};

export const useGlobalStore = create<GlobalState & Actions>()(
  persist(
    (set, get) => ({
      currentSystem: {},
      selectedInspectionConfiguration: 'Custom',
      // inspectionConfigurations: [{ ...defaultInspectionConfiguration }],

      inspectionConfigurations: [],
      quality_standards: [],
      isStoreHydrated: false,
      fetchSystemData: async () => {
        try {
          const res = await fetch(`${acqUrl}status`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json'
            }
          });
          if (!res.ok) {
            console.error(`GET status failed with status ${res.status}`);
            return;
          }

          const parsed = await res.json();

          // Keep the last good system unless the body carries an object.
          const data = parsed?.data;
          if (data === null || typeof data !== 'object' || Array.isArray(data)) {
            console.error('GET status returned no data object');
            return;
          }

          set({ currentSystem: data });
        } catch (error) {
          console.error('Error fetching system data:', error);
        }
      },
      updateSelectedInspectionConfiguration: (
        inspectionConfiguration: string
      ) => {
        set((state) => ({
          selectedInspectionConfiguration:
            (state.selectedInspectionConfiguration = inspectionConfiguration)
        }));
      },
      fetchInspectionConfiguration: async () => {
        // console.log('Fetching inspection configurations from global store');

        try {
          const res = await fetch(`${baseUrl}api/v2/inspection-configuration`, {
            method: 'GET',
            credentials: 'include',
            headers: {
              'Content-Type': 'application/json'
            }
          });

          if (res.status === 200) {
            const parsed = await res.json();
            console.log(
              'parsed inspection configurations from global store: ',
              parsed
            );

            // Keep the persisted copy (the offline source) unless the body is a list.
            if (!Array.isArray(parsed?.data)) {
              console.error(
                'GET inspection-configuration returned no data array'
              );
              return;
            }

            // Keep the reference when nothing changed: /inspect re-loads
            // inspection/current on every new list reference, and that GET
            // can overwrite edits typed in the meantime.
            if (
              JSON.stringify(parsed.data) ===
              JSON.stringify(get().inspectionConfigurations)
            ) {
              return;
            }

            set({ inspectionConfigurations: parsed.data });
          } else if (res.status === 401) {
            if (typeof window !== 'undefined') {
              clearClientStores();
              window.location.assign('/auth/logout');
            }
          }
        } catch (error) {
          // Offline: keep the persisted templates so /inspect stays usable.
          console.error('Error fetching inspection configurations:', error);
        }
      },
      fetchQualityStandard: async () => {
        console.log('Fetching quality standards from global store.');

        try {
          const res = await fetch(`${baseUrl}api/v2/quality-standard`, {
            method: 'GET',
            credentials: 'include',
            headers: {
              'Content-Type': 'application/json'
            }
          });

          if (res.status === 200) {
            const parsed = await res.json();
            // console.log('parsed quality standards from global store: ', parsed);

            // Keep the persisted copy (the offline source) unless the body is a list.
            if (!Array.isArray(parsed?.data)) {
              console.error('GET quality-standard returned no data array');
              return;
            }

            set({ quality_standards: [...parsed.data] });
          } else if (res.status === 401) {
            if (typeof window !== 'undefined') {
              clearClientStores();
              window.location.assign('/auth/logout');
            }
          }
        } catch (error) {
          // Offline: keep the persisted standards so /inspect stays usable.
          console.error('Error fetching quality standards:', error);
        }
      },
      // Replaced by /inspect setting the selection from the result of
      // scanStore.getCurrentInspection (same GET inspection/current).
      // getCurrentInspection: async () => {
      //   try {
      //     const res = await fetch(
      //       `${process.env.NEXT_PUBLIC_ACQUISITION}inspection/current`,
      //       {
      //         method: 'GET',
      //         headers: {
      //           'Content-Type': 'application/json'
      //         }
      //       }
      //     );
      //     if (res.ok) {
      //       const parsed = await res.json();
      //       console.log(
      //         'GLOBALSTORE: Parsed res from GET inspection/current',
      //         parsed
      //       );
      //       console.log(
      //         'GLOBALSTORE: Parsed INSPECTION_CONFIG from GET inspection/current',
      //         parsed.inspection_configuration
      //       );
      //
      //       if (
      //         typeof parsed.inspection_configuration === 'string' &&
      //         parsed.inspection_configuration.length === 24
      //       ) {
      //         //inspection configuration is a template
      //         set((state) => ({
      //           selectedInspectionConfiguration:
      //             (state.selectedInspectionConfiguration =
      //               parsed.inspection_configuration)
      //         }));
      //       } else if (
      //         parsed.inspection_configuration !== null &&
      //         typeof parsed.inspection_configuration === 'object'
      //       ) {
      //         //inspection configuration is a custom configuration
      //         set((state) => ({
      //           selectedInspectionConfiguration:
      //             (state.selectedInspectionConfiguration = 'Custom')
      //         }));
      //       }
      //     } else {
      //       console.log(
      //         `GET inspection/current failed with status: ${res.status}`
      //       );
      //     }
      //   } catch (error) {
      //     console.log('Error from getCurrentInspection');
      //   }
      // },
      resetStore: () => {
        set((state) => ({
          currentSystem: {},
          selectedInspectionConfiguration: 'Custom',
          // inspectionConfigurations: [{ ...defaultInspectionConfiguration }],

          inspectionConfigurations: [],
          quality_standards: []
          // isStoreHydrated: false
        }));
      },
      setIsStoreHydrated: (isHydrated: boolean) => {
        set((state) => ({
          isStoreHydrated: (state.isStoreHydrated = isHydrated)
        }));
      }
    }),
    {
      name: GLOBAL_STORE_NAME,
      onRehydrateStorage: () => (state) => {
        state?.setIsStoreHydrated(true);
      }
    }
  )
);
